var _path, _path2, _mask, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStakeProgress = function SvgStakeProgress(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 76,
    height: 72,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#stake-progress_svg__a)",
    strokeWidth: 6.035,
    d: "M72.782 36.404c0 18.015-14.48 32.578-32.29 32.578S8.205 54.42 8.205 36.404 22.684 3.825 40.493 3.825s32.289 14.563 32.289 32.579Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "url(#stake-progress_svg__b)",
    strokeWidth: 6.035,
    d: "M67.796 35.596c0-18.015-14.48-32.578-32.29-32.578S3.219 17.58 3.219 35.596s14.48 32.579 32.289 32.579 32.289-14.563 32.289-32.579Z"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "stake-progress_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M21.11 38.086a3.026 3.026 0 0 1 0-4.255l12.574-12.677a2.96 2.96 0 0 1 2.522-.852 2.96 2.96 0 0 1 2.163.88l12.57 12.673a3.026 3.026 0 0 1 0 4.255 2.967 2.967 0 0 1-4.221 0l-7.724-7.787V49.46a2.984 2.984 0 0 1-5.968 0V30.327l-7.696 7.76a2.967 2.967 0 0 1-4.22 0",
    clipRule: "evenodd"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M21.11 38.086a3.026 3.026 0 0 1 0-4.255l12.574-12.677a2.96 2.96 0 0 1 2.522-.852 2.96 2.96 0 0 1 2.163.88l12.57 12.673a3.026 3.026 0 0 1 0 4.255 2.967 2.967 0 0 1-4.221 0l-7.724-7.787V49.46a2.984 2.984 0 0 1-5.968 0V30.327l-7.696 7.76a2.967 2.967 0 0 1-4.22 0",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#stake-progress_svg__c)",
    d: "m21.11 33.831-4.286-4.25zm12.574-12.677 4.285 4.25zm2.522-.852-.836 5.977.469.065.474-.008zm2.163.88-4.285 4.25zm12.57 12.673 4.284-4.25zm0 4.255 4.284 4.25zm-4.221 0 4.285-4.25zm-7.724-7.787 4.286-4.25-10.32-10.405v14.655zm-5.968.004h6.035V15.672l-10.32 10.405zm-7.696 7.76 4.285 4.25zm-8.506-8.506c-3.499 3.528-3.499 9.228 0 12.756l8.57-8.5a3.01 3.01 0 0 1 0 4.245zm12.574-12.677L16.825 29.581l8.57 8.5L37.97 25.405zm7.645-2.58a9 9 0 0 0-7.645 2.58l8.57 8.5a3.07 3.07 0 0 1-2.598.875zm5.61 2.608a9 9 0 0 0-6.553-2.665l.212 12.07a3.07 3.07 0 0 1-2.228-.904zm12.57 12.673-12.57-12.673-8.57 8.5 12.57 12.673zm0 12.755c3.5-3.528 3.5-9.227 0-12.755l-8.57 8.5a3.01 3.01 0 0 1 0-4.245zm-12.79 0a9 9 0 0 0 12.79 0l-8.57-8.5a3.07 3.07 0 0 1 4.35 0zm-7.724-7.787 7.724 7.787 8.57-8.5-7.723-7.787zm-1.75-4.25V49.46h12.07V30.323zm0 19.137a3.05 3.05 0 0 1 3.051-3.051v12.07a9.02 9.02 0 0 0 9.02-9.019zm3.051-3.051a3.05 3.05 0 0 1 3.052 3.051H26.99a9.02 9.02 0 0 0 9.02 9.02zm3.052 3.051V30.327H26.99V49.46zm-9.447-7.123 7.696-7.76-8.57-8.5-7.696 7.76zm-12.79 0a9 9 0 0 0 12.79 0l-8.57-8.5a3.07 3.07 0 0 1 4.35 0z",
    mask: "url(#stake-progress_svg__d)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "stake-progress_svg__a",
    x1: 40.493,
    x2: 40.493,
    y1: 0.808,
    y2: 72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A56F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    stopColor: "#B7379A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB970"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "stake-progress_svg__b",
    x1: 39.469,
    x2: 35.442,
    y1: 100.1,
    y2: 0.003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.304,
    stopColor: "#C653C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#EF420A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEED6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "stake-progress_svg__c",
    x1: 55.36,
    x2: 40.617,
    y1: 26.967,
    y2: 13.745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.304,
    stopColor: "#C653C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#EF420A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEED6E"
  })))));
};
export default SvgStakeProgress;